import { createContext, ReactElement, useContext } from "react";
import GetEvents, { ResponseMembrosCheckin } from "../services/getMembros";
import CargoServices, { TCargoServices } from "../services/setCargo";

export const ListaContext = createContext<ResponseMembrosCheckin & TCargoServices>(null);

export const ProviderListMembro = ({children}: { children: ReactElement }) => {

  const context = GetEvents();

  const cont = CargoServices({ reset: context?.refetch });

  return (
    <>
      <ListaContext.Provider value={{...context, ...cont}}>
        {children}
      </ListaContext.Provider>
    </>
  )
}

export const UseListMembros = () => {
  const context = useContext(ListaContext);
  return context;
}
